import gql from 'graphql-tag';
import {
  AddressComponentDataChange,
  AuditCheckboxComponentDataChange,
  AuditTagComponentDataChange,
  AuditTextComponentDataChange,
  DateComponentDataChange,
  EmailComponentDataChange,
  FileComponentDataChange,
  GeolocationComponentDataChange,
  NumberComponentDataChange,
  PersonComponentDataChange,
  RelatedCardComponentDataChange,
  ScheduledAutomationComponentDataChange,
  SignatureComponentDataChange,
  SubformComponentDataChange,
  TagComponentDataChange,
  TextComponentDataChange,
  TimeTrackerComponentDataChange,
  TodoComponentDataChange,
  UrlComponentDataChange,
} from './component';

export const change = gql`
  fragment AnyComponentDataChange on AnyComponentDataChange {
    ...AddressComponentDataChange
    ...AuditCheckboxComponentDataChange
    ...AuditTagComponentDataChange
    ...AuditTextComponentDataChange
    ...DateComponentDataChange
    ...EmailComponentDataChange
    ...FileComponentDataChange
    ...GeolocationComponentDataChange
    ...NumberComponentDataChange
    ...PersonComponentDataChange
    ...RelatedCardComponentDataChange
    ...ScheduledAutomationComponentDataChange
    ...SignatureComponentDataChange
    ...SubformComponentDataChange
    ...TagComponentDataChange
    ...TextComponentDataChange
    ...TimeTrackerComponentDataChange
    ...TodoComponentDataChange
    ...UrlComponentDataChange
  }

  ${AddressComponentDataChange}
  ${AuditCheckboxComponentDataChange}
  ${AuditTagComponentDataChange}
  ${AuditTextComponentDataChange}
  ${DateComponentDataChange}
  ${EmailComponentDataChange}
  ${FileComponentDataChange}
  ${GeolocationComponentDataChange}
  ${NumberComponentDataChange}
  ${PersonComponentDataChange}
  ${RelatedCardComponentDataChange}
  ${ScheduledAutomationComponentDataChange}
  ${SignatureComponentDataChange}
  ${SubformComponentDataChange}
  ${TagComponentDataChange}
  ${TextComponentDataChange}
  ${TimeTrackerComponentDataChange}
  ${TodoComponentDataChange}
  ${UrlComponentDataChange}
`;
